import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'OverallStudentDescription',
  setup(__props) {

const $route = useRoute();
const student_id: string = $route.params.id as string;

return (_ctx: any,_cache: any) => {
  const _component_student_description = _resolveComponent("student-description")!
  const _component_curriculum_list = _resolveComponent("curriculum-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_student_description, { id: _unref(student_id) }, null, 8, ["id"]),
    _createVNode(_component_curriculum_list, { student_id: _unref(student_id) }, null, 8, ["student_id"])
  ], 64))
}
}

})